/* eslint-disable */
export default {
  mute: 'Desativar som',
  unmute: 'Ativar som',
  hangup: 'Desligar',
  reject: 'Rejeitar',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
